import {Component, EventEmitter, Input, Output} from "@angular/core";

import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'search-bar',
    imports: [FontAwesomeModule, FormsModule],
    templateUrl: './search-bar.component.html',
    styleUrls: ['../dropdown-search/dropdown-search.css']
})
export class SearchBarComponent {
  @Input('searchText') searchText: string = ""
  @Input('style') style = "flex w-[350px] mb-1 input mt-2"
  @Input('placeholderText') placeholderText: string = "Search..."
  @Output('searchTextChange') searchTextChange = new EventEmitter<string>()
  @Output() debounceSearch = new EventEmitter<Function>()
  searchIconStyle = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; margin-left: 0.5rem; flex-shrink: 1;`
  faMagnifyingGlass = faMagnifyingGlass

  onChange() {
    this.searchTextChange.emit(this.searchText)
    this.debounceSearch.emit(this.debounceSearch)
  }
}
